import '@stoplight/elements-dev-portal/styles.min.css'

import { FunctionComponent } from 'react'
import { StoplightProject } from '@stoplight/elements-dev-portal'

const NexusAPIDocs: FunctionComponent = () => {
  return (
    <>
      <StoplightProject
        basePath="nexus-api"
        projectId={process.env.REACT_APP_STOPLIGHT_NEXUS_API_ID || ''}
      />
    </>
  )
}

export default NexusAPIDocs
